import { Redirect, Route as ReactRoute } from "react-router-dom";
import { useAuth } from "../providers/users";

export function Route({
  component: Component,
  isPrivate = false,
  isPublic = false,
  ...rest
}) {
  const { accessToken } = useAuth();

  return (
    <ReactRoute
      {...rest}
      render={() =>
        isPrivate === !!accessToken ? (
          <Component />
        ) : isPublic ? (
          <Component />
        ) : (
          <Redirect to={isPrivate ? "/" : "/dashboard"} />
        )
      }
    ></ReactRoute>
  );
}
